export default "__VITE_ASSET__Jlo34QqL__"